import { AssetsResponse } from '../types/assets.types';

// Uploaded files are stored as "<24-character id>_<name>": show the name
// the user gave the file.
export const getAssetDisplayName = (
  asset: Pick<AssetsResponse, 'fileName' | 'originalName'>,
) => {
  const hasGeneratedPrefix = /^[a-f0-9]{24}_/i.test(asset.fileName);
  return hasGeneratedPrefix
    ? asset.originalName || asset.fileName.replace(/^[a-f0-9]{24}_/i, '')
    : asset.fileName;
};
